/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Header_Trending_HeadingInputs */

const en_header_trending_heading = /** @type {(inputs: Header_Trending_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The trend list`)
};

/**
* | output |
* | --- |
* | "The trend list" |
*
* @param {Header_Trending_HeadingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const header_trending_heading = /** @type {((inputs?: Header_Trending_HeadingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Header_Trending_HeadingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_header_trending_heading(inputs)
});
export { header_trending_heading as "header.trending.heading" }